import { createSlice } from '@reduxjs/toolkit';

import { updateSearchParams } from '../common/reducers/updateSearchParams.reducers';

import { INITIAL_INBOX_DOCUMENTS_STATE } from './inbox.state';

const slice = createSlice({
  name: 'inboxDocuments',
  initialState: INITIAL_INBOX_DOCUMENTS_STATE,
  reducers: {
    updateSearchParams,
  },
});

export const InboxDocumentsActions = slice.actions;

export const documentInboxReducer = slice.reducer;
